<template>
	<div v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin">
		<BaseHeader :title="$t('service_provider').toString()" fontawesome-title="tools" />

		<ServiceProviderDamageAssessorApplicationsCard />
		<ServiceProviderLawyersOfficesApplicationsCard />

		<ServiceProviderDamageAssessorCard />
		<ServiceProviderLawyersOfficesCard />
		<!-- modal wrapper -->
		<router-view />
	</div>
	<Forbidden v-else />
</template>

<script>
import ServiceProviderDamageAssessorCard from '@/views/management/RepairShop/ServiceProviderDamageAssessorCard';
import ServiceProviderLawyersOfficesCard from '@/views/management/RepairShop/ServiceProviderLawyersOfficesCard';
import BaseHeader from '@/components/navigation/BaseHeader';
import ServiceProviderDamageAssessorApplicationsCard from '@/views/management/RepairShop/ServiceProviderDamageAssessorApplicationsCard';
import ServiceProviderLawyersOfficesApplicationsCard from '@/views/management/RepairShop/ServiceProviderLawyersOfficesApplicationsCard';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'ServiceProviderOverview',
	mixins: [Authentication],
	components: {
		Forbidden,
		ServiceProviderLawyersOfficesApplicationsCard,
		ServiceProviderDamageAssessorApplicationsCard,
		BaseHeader,
		ServiceProviderLawyersOfficesCard,
		ServiceProviderDamageAssessorCard,
	},
};
</script>

<style scoped></style>
